import React from 'react';

import CheckMark from '../../../../common/img/components/Checkmark';
import styles from './OfferDetails.module.scss';

const OfferDetails = () => {
  const offerBulletText = [
    { text: ' Displayed indefinitely in our Press Release section', key: 1 },
    { text: ' Rotated in our Press Release sidebar box', key: 2 },
    { text: ' Distributed in at least one newsletter', key: 3 },
    { text: ' Ability to include a company logo and header image', key: 4 },
    { text: ' Editable at any time', key: 5 },
    { text: ' Can be posted anytime in the next year', key: 6 },
  ];

  const offerBullets = offerBulletText.map((offer) => {
    return (
      <div key={offer.key} className={styles['offer-bullet']}>
        <CheckMark />
        <span className={styles['offer-text']}>{offer.text}</span>
      </div>
    );
  });

  return (
    <aside className={styles['offer-container']}>
      <div className={styles['offer-header']}>Included with each press release</div>
      <div className={styles['offer-bullet']}>
        <CheckMark />
        <span className={styles['offer-text']}>
          Can be published on any one of our <a href="https://www.industrydive.com/post-press-release/">Industry Dive publications</a>
        </span>
      </div>
      {offerBullets}
      <em>
        Find answers to commonly asked questions about DiveWire Press Release{' '}
        <a className="analytics t-pr-bpc-faq" href="https://www.industrydive.com/divewire-faq">here</a>.
      </em>
    </aside>
  );
};

export default OfferDetails;
